import React from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useEffect } from "react";
import { useState } from "react";

const useFieldMarketerDetails = () => {
  const axiosPrivate = useAxiosPrivate();
  const [details, setDetails] = useState({
    fieldMarketer: [],
    totalActive: 0,
    totalInactive: 0,
  });

  const getFieldMarketer = async () => {
    try {
      const response = await axiosPrivate.get(
        "/card-service/cms/admin/marketers/all"
      );
      if (response?.data?.status === true || response?.data) {
        const marketers = response?.data?.data || response?.data || [];
        const totalActive = marketers.filter((m) => m.active).length;
        const totalInactive = marketers.filter((m) => !m.active).length;
        setDetails({
          fieldMarketer: marketers,
          totalActive,
          totalInactive,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFieldMarketer();
  }, []);

  return { ...details, refetch: getFieldMarketer };
};

export default useFieldMarketerDetails;
